var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17137 8.28742V7.89536C6.17137 7.65519 6.19884 7.44327 6.2538 7.2596C6.30875 7.07241 6.39696 6.89581 6.51844 6.7298C6.63991 6.56027 6.80043 6.3872 7 6.2106C7.17932 6.05519 7.32249 5.91567 7.4295 5.79205C7.53941 5.66843 7.61894 5.54658 7.66811 5.42649C7.72017 5.30287 7.7462 5.16336 7.7462 5.00795C7.7462 4.77837 7.67679 4.60353 7.53796 4.48344C7.39913 4.36336 7.20535 4.30331 6.95662 4.30331C6.70788 4.30331 6.46059 4.35099 6.21475 4.44636C5.9718 4.54172 5.72451 4.66711 5.47289 4.82252L5 3.66225C5.28923 3.46446 5.60304 3.30552 5.94143 3.18543C6.27983 3.06181 6.65004 3 7.05206 3C7.67101 3 8.14967 3.1819 8.48807 3.5457C8.82936 3.90596 9 4.36512 9 4.92318C9 5.21987 8.96095 5.4777 8.88286 5.69669C8.80766 5.91214 8.69197 6.11347 8.53579 6.30066C8.3825 6.48433 8.19017 6.67859 7.95879 6.88344C7.78525 7.03885 7.65221 7.16954 7.55965 7.2755C7.4671 7.38146 7.40347 7.48742 7.36876 7.59338C7.33695 7.69581 7.32104 7.82119 7.32104 7.96954V8.28742H6.17137ZM6.03254 10.0993C6.03254 9.76733 6.10629 9.53422 6.2538 9.4C6.40419 9.26578 6.58496 9.19868 6.7961 9.19868C7.00145 9.19868 7.17787 9.26578 7.32538 9.4C7.47578 9.53422 7.55098 9.76733 7.55098 10.0993C7.55098 10.4172 7.47578 10.6468 7.32538 10.7881C7.17787 10.9294 7.00145 11 6.7961 11C6.58496 11 6.40419 10.9294 6.2538 10.7881C6.10629 10.6468 6.03254 10.4172 6.03254 10.0993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.830b1542084961fa73669b39f73e686a.svg";
export { ForwardRef as ReactComponent };